import Vue from 'vue';
import { getStoreBuilder, BareActionContext } from 'vuex-typex';
import { AxiosError } from 'axios';
import authAxios from '@/state/auth-axios'; // Use this to make okta-auth'd axios requests
import rootStore from '@/state/store';

// === STATE - Prepare initial state, store builder
export const initialOpportunitiesState: IOpportunitiesStore = {
	opportunities: [],
	opportunitiesToken: 50
};

// Prepare store builder for use throughout
const storeBuilder = getStoreBuilder<IRootStore>();
const moduleBuilder = storeBuilder.module<IOpportunitiesStore>(
	'opportunities',
	initialOpportunitiesState,
);

// === GETTERS - Like computed data or used to get a part of the data or return it in a specific way and cache it

// === MUTATIONS - Synchronous work that mutates the data store. Should be quick
const SET_OPPORTUNITIES_MUTATION = (
	state: IOpportunitiesStore,
	data: IOpportunityList,
) => {
	Vue.set(state, "opportunities", data); // For reactivity
};
const SET_OPPORTUNITIES_TOKEN_MUTATION = (
	state: IOpportunitiesStore,
	data: number,
) => {
	Vue.set(state, "opportunitiesToken", data); // For reactivity
};

// === ACTIONS - Asynchronous work that gets data, changes the data for storage, and handles errors.
const GET_OPPORTUNITIES_ACTION = (
	{}: BareActionContext<IOpportunitiesStore, IRootStore>,
	params: IFetchOpportunitiesParams
): Promise<IOpportunityList> => {
	return fetchOpportunities(params)
		.then((data: IOpportunityList) => {
			opportunitiesStore.commitSetOpportunities(data);
			return data;
		});
};

// === SERVICES
interface IFetchOpportunitiesParams {
	params: any;
}
const fetchOpportunities = (args: IFetchOpportunitiesParams): Promise<IOpportunityList> => {
	const {
		params
	} = args;

	// prepare url for request
	const config = rootStore.state.config as ISiteConfig;
	const url = `${config.partnerServiceUrl}/opportunities`;

	// Create request and return promise for processed data
	return authAxios.get(url, {
			params,
		})
		.then((response) => {
			const { data }: { data: any } = response; // remove headers

			const opportunities: IOpportunityList = [];

			// Transform opportunities
			if (data.length>0) {
				data.forEach((entry: IOpportunity) => {
					if (entry.phone) {
						entry.phone = entry.phone.replace(/[^\d]/, "");
					}
					opportunities.push(entry);
				});

			}

			return opportunities;
		})
		.catch((err: AxiosError) => {
			throw err;
		});
};

// === EXPORTS - Modules state or storage handling. Gets combined with the root store on compile or run.
// Prepare this module's state for export
const stateGetter = moduleBuilder.state();

// exported module interface
const opportunitiesStore = {
	// state
	get state() { return stateGetter(); },

	// getters

	// mutations
	commitSetOpportunities: moduleBuilder.commit(SET_OPPORTUNITIES_MUTATION, 'SET_OPPORTUNITIES'),
	commitSetOpportunitiesToken: moduleBuilder.commit(SET_OPPORTUNITIES_TOKEN_MUTATION, "SET_OPPORTUNITIES_TOKEN"),

	// action
	dispatchGetOpportunities: moduleBuilder.dispatch(
		GET_OPPORTUNITIES_ACTION,
		'getOpportunities',
	),
};

// Export default store object
export default opportunitiesStore;
